/**
 * On scroll reveal animations
 *
 * Does nothing when:
 *   - prefers-reduced-motion: reduce is active
 *   - There are no [data-animate] elements on the page
 *
 * Usage:
 *   <div data-animate>                    Default fade-up
 *   <div data-animate="fade-left">        Specific variant
 *   <div data-animate-delay="200">        Manual delay in ms
 *   <div data-animate-group>              Stagger: children 80ms apart
 *   <div data-animate-group="120">        Stagger with custom timing
 */

function initScrollAnimate() {
	// User has disabled motion in the OS.
	// Early return: does not touch the DOM; elements stay fully visible.
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	// Stagger groups: direct children get data-animate + increasing delays
	document.querySelectorAll('[data-animate-group]').forEach((group) => {
		const stagger = parseInt(group.dataset.animateGroup) || 80;

		Array.from(group.children).forEach((child, index) => {
			if (!child.hasAttribute('data-animate')) {
				child.setAttribute('data-animate', '');
			}
			// Stagger delay is added to any existing manual delay
			const existing = parseInt(child.dataset.animateDelay) || 0;
			child.dataset.animateDelay = existing + index * stagger;
		});
	});

	const elements = document.querySelectorAll('[data-animate]');

	// No elements on the page = do not create an observer
	if (!elements.length) return;

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;

				const el = entry.target;
				const delay = parseInt(el.dataset.animateDelay) || 0;

				setTimeout(() => {
					// Force reflow so the initial state (opacity: 0) is painted before we add is-visible.
					// Without this, opacity can jump from 0 to 1 without transitioning (e.g. in Swiper slides).
					el.offsetHeight;
					el.classList.add('is-visible');
				}, delay);
				observer.unobserve(el); // After animation: stop observing
			});
		},
		{
			rootMargin: '0px 0px -10% 0px',
			threshold: 0.1,
		}
	);

	elements.forEach((el) => observer.observe(el));
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initScrollAnimate);
} else {
	initScrollAnimate();
}
